// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AliwangwangOutlinedSvg from "@ant-design/icons-svg/es/asn/AliwangwangOutlined";
import AntdIcon from '../components/AntdIcon';

var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangOutlinedSvg
  }));
};

AliwangwangOutlined.displayName = 'AliwangwangOutlined';
export default React.forwardRef(AliwangwangOutlined);